import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/iglf-logo.png'
import { ReactComponent as CartIcon } from '../../assets/cart.svg'
import { ReactComponent as User } from '../../assets/user.svg'
import { ReactComponent as DownArrow } from '../../assets/down-arrow.svg'

const Header = ({context}) => {


    const toggleDropdown = function (){
        const menu = document.getElementById("main-menu");
        const arrow = document.getElementById("down-arrow-icon");
        if (menu.style.display === "flex"){
            menu.style.display = "none";
            arrow.style.transform = "rotate(0deg)"
        } else {
            menu.style.display = "flex";
            arrow.style.transform = "rotate(180deg)"
        }
    }

    return (
        <header>
            <div className="header-logo">
                <Link to="/">
                    <img src={logo} alt="It's A Good Life Logo" width="100%" height="100%" />
                </Link>
            </div>
            <nav className="nav-links">
                <Link to="/services/">
                    Services
                </Link>
                <div className="line">
                </div>
                <Link to="/about/">
                    About
                </Link>
                <div className="line">
                </div>
                <Link to="/contact/">
                    Contact
                </Link>
                <div className="line">
                </div>
                <Link to="/packages/">
                    Packages
                </Link>
                <div className="line">
                </div>
                <Link to="/individual/">
                    Individual Sessions
                </Link>
                <div className="line">
                </div>
                <Link to="/faq/">
                    FAQ
                </Link>
            </nav>
            <div className="nav-icons">
                <a href="https://iglf.peak-ws.com/" title="Member Login" target="_blank" rel="noopener noreferrer">
                    <User id="user-icon" />
                </a>
                <Link to="/checkout/" title={context.cart.length > 0 ? ("Checkout"):("No items in cart")}>
                    <CartIcon id={context.cart.length > 0 ? ("cart-icon-full"):("cart-icon")} />
                </Link>
                <button title="Menu" id="down-arrow" onClick={(e) => toggleDropdown(e)}>
                    <DownArrow id="down-arrow-icon"/>
                </button>
            </div>
            <div className="dropdown-menu" id="main-menu">
                <div className="dropdown-links">
                    <Link to="/services/" onClick={(e) => toggleDropdown(e)}>
                        Services
                    </Link>
                    <Link to="/about/" onClick={(e) => toggleDropdown(e)}>
                        About
                    </Link>
                    <Link to="/contact/" onClick={(e) => toggleDropdown(e)}>
                        Contact
                    </Link>
                    <Link to="/packages/" onClick={(e) => toggleDropdown(e)}>
                        Packages
                    </Link>
                    <Link to="/individual/" onClick={(e) => toggleDropdown(e)}>
                        Individual Sessions
                    </Link>
                    <Link to="/faq/" onClick={(e) => toggleDropdown(e)}>
                        FAQ
                    </Link>
                </div>
            </div>
            {/* <Cart modalIsOpen={modalIsOpen} closeModal={closeModal} context={context} /> */}
        </header>
    )
}

export default Header;